import { usePersistStore } from "../../store/persistStore";
import { EJWTStatus, validateJWT } from "./validateJWT";

/** Run once before creating the router, after synchronous localStorage hydration. */
export function resetUnfinishedLoginOnStartup() {
  const state = usePersistStore.getState();
  if (validateJWT(state.deviceJWT) === EJWTStatus.Invalid && state.jwt) {
    state.clearJwt();
  }
}
